import { type SpecificationBandData } from "../../dto/PdpPageProductDataDto";
import { PRODUCT_VARIANT_TABLE_TOGGLE_THRESHOLD } from "../../../utils/constants";
import { createColumnHelper } from "@tanstack/react-table";
import { TanStackTable } from "~/common/components/Table/TanStackTable";
import { PartiallyCollapsedTableWrapper } from "~/ProductDetails/components/DataTables/PartiallyCollapsedTableWrapper";
import { useTranslation } from "react-i18next";

import { isNonNull } from "~/utils/reducers";

interface SpecificationsBandProps {
  data: SpecificationBandData[];
}

export const ProductVariantTable = ({ data }: SpecificationsBandProps) => {
  const { t } = useTranslation();
  if (!data || data.length === 0) {
    return null;
  }

  const anyDescriptionPresent = data.some((item) => item.description);
  const tableTitle = t("productDetailsPage.specificationsBandTitle");

  const columnHelper = createColumnHelper<SpecificationBandData>();

  const columns = [
    columnHelper.accessor("parentCategoryDescription", {}),
    columnHelper.accessor("name", {}),
    anyDescriptionPresent && columnHelper.accessor("description", {}),
  ].filter(isNonNull);

  return (
    <PartiallyCollapsedTableWrapper maxItemLimit={PRODUCT_VARIANT_TABLE_TOGGLE_THRESHOLD} items={data}>
      {(ref) => <TanStackTable data={data} columns={columns} tableTitle={tableTitle} rootRef={ref} fullwidth={true} />}
    </PartiallyCollapsedTableWrapper>
  );
};
